module.exports = __webpack_public_path__ + "static/media/Download_Salary.86bc0989.svg";